import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalWifiStatusbarNullIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_wifi_statusbar_null"}/>
}
